export default __webpack_public_path__ + "static/media/ic_bolt_outlinel.71b45cef.svg";